import {Subscribable} from "./subscribable";
import {AuthenticationOptions, AuthenticationStatus} from "./typing";
import {AuthenticationManager} from "./authenticationManager";
import {Authentication, AuthenticationState, initialState} from "./authentication";


export interface AuthenticationObserverOptions<
    TVariables,
    TPrincipal
> extends AuthenticationOptions<TVariables, TPrincipal> {
    // throwOnError?: boolean | ((error: Error) => boolean)
}
interface AuthenticationObserverBaseResult<TVariables, TPrincipal> extends AuthenticationState<TVariables, TPrincipal> {
    principal: TPrincipal | undefined;

    variables: TVariables | undefined;

    error: Error | null;

    isIdle: boolean;

    isPending: boolean;

    status: AuthenticationStatus;

    authenticate: (variables: TVariables) => Promise<TPrincipal>;

}
interface AuthenticationObserverIdleResult<TVariables, TPrincipal> extends AuthenticationObserverBaseResult<TVariables, TPrincipal> {
    status: 'idle';

}
export type AuthenticationObserverResult<TVariables, TPrincipal> =
    | AuthenticationObserverIdleResult<TVariables, TPrincipal>
    | AuthenticationObserverBaseResult<TVariables, TPrincipal>;

type AuthenticationObserverListener<TVariables, TPrincipal> = (
    result: AuthenticationObserverResult<TVariables, TPrincipal>
) => void;



export class AuthenticationObserver<TVariables, TPrincipal> extends Subscribable<AuthenticationObserverListener<TVariables, TPrincipal>>{
    options: AuthenticationObserverOptions<TVariables, TPrincipal>
    client: AuthenticationManager<TPrincipal>;
    currentResult!: AuthenticationObserverResult<TVariables, TPrincipal>;
    currentAuthentication?: Authentication<TVariables, TPrincipal>;

    constructor(
        client: AuthenticationManager<TPrincipal>,
        options: AuthenticationObserverOptions<TVariables, TPrincipal>,
    ) {
        super();
        this.client = client;
        this.options = options;
        this.updateResult();
    }

    authenticate = (
        variables: TVariables
    ) => {
        this.currentAuthentication = this.client.authenticate<TVariables>(variables, this.options);
        this.currentAuthentication.subscribe(() => {
            this.updateResult();
            this.emit();
        })
        return this.currentAuthentication.execute(variables);
    }

    updateResult() {
        const authentication = this.currentAuthentication;
        const state = authentication?.state??initialState();
        const {
            status
        } = state;
        this.currentResult = {
            ...state,
            isPending: status === 'pending',
            isIdle: status === 'idle',
            authenticate: this.authenticate
        }
    }

    getCurrentResult(): AuthenticationObserverResult<TVariables, TPrincipal> {
        return this.currentResult;
    }
}